module.exports = __webpack_public_path__ + "static/img/bg-introVideo@2x.e67ce44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/bg-introVideo@2x.png
// module id = L3xc
// module chunks = 18